module.exports = __webpack_public_path__ + "static/media/Saly-24.54978293.png";